<template>
    <div>
        <div class="locations-container">
            <div @click="openSelector(location)" v-for="(location, index) in locations" :key="index" class="row mx-2 py-3" style="background-color: white; box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.05); cursor: pointer">
                <div class="col-1">
                    <span><img src="/icons/location_picker-sm.png" style="position: relative; top: 5px" /></span>
                </div>
                <div class="col text-start">
                    <div class="row" style="font-weight: 700">{{ location.title }}</div>
                    <div class="row">{{ location.formatted_address }}</div>
                </div>
                <div class="col-1">
                    <span @click.stop="deleteItem({ lat: location.lat, lng: location.lng })" class="me-2 trash"><img src="/icons/all/outline/trash.svg" style="padding-right: 10px; transform: scale(0.9); position: relative; top: 15px" /></span>
                </div>
            </div>
        </div>
        <div class="row blue-filter">
            <div class="col my-2 text-end"><span @click="openSelector(true)" style="cursor: pointer">Add Location +</span></div>
        </div>

        <div v-if="stageIndex === 2" id="navigation" class="row my-2 p-0" style="right: 10px">
            <div class="col">
                <span v-if="stages.length == stageIndex + 1" @click="approve()" style="float: right" class="mx-2 btn btn-usfc-primary">Approve Booking</span>
                <button :disabled="!bodyForm.userId" v-else @click="nextStage()" style="float: right" class="mx-2 btn btn-usfc-primary">Next</button>
                <span @click="this.$store.state.app.openModal = ''" v-if="stageIndex == 0" style="float: right" class="mx-2 btn btn-cancel"> Cancel</span>
                <span @click="prevStage()" v-else style="float: right" class="mx-2 btn btn-back"> Back</span>
            </div>
        </div>

        <div v-if="selector" class="location-picker">
            <div id="modalTitle" class="row">
                <div class="col p-2">
                    <h5>
                        <span class="p-2" style="font-weight: 700; float: left">Select Location </span>
                        <span @click="selector = false" id="closeModal"><img class="d-flex justify-content-center" src="/icons/all/outline/add.svg" /></span>
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="label-float">
                        <input @blur="clearSuggestion()" @input="debouncedOnChange" v-model="gmaps.searchQuery" id="address" type="text" placeholder=" " autocomplete="off" />
                        <label>Find Address</label>

                        <div @click="requestGeo()" style="cursor: pointer"><img style="position: absolute; top: 30px; right: 10px" src="@/assets/gps.svg" /></div>
                    </div>
                </div>
            </div>
            <div v-if="gmaps.suggestions.length > 0" id="suggestions" class="row p-1 bg-white">
                <div class="col p-0">
                    <div @click="selectLocation(suggestion.geometry)" v-for="suggestion in gmaps.suggestions" :key="suggestion.place_id" class="row py-1 px-0 mx-0 suggestion">
                        <div class="col-1 d-flex"><img class="m-auto" src="@/assets/location.svg" /></div>
                        <div class="col">
                            <div class="row" style="font-weight: 600">
                                {{ suggestion.name }}
                            </div>
                            <div class="row" style="font-size: 12px">
                                {{ suggestion.formatted_address }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <!-- KEY AIzaSyCzYRio6GWqdf03CAd9Gs1sjS8b6fuIAyM -->
                    <GoogleMap
                        api-key="AIzaSyCzYRio6GWqdf03CAd9Gs1sjS8b6fuIAyM"
                        @click="markerCallback($event.latLng)"
                        style="width: 100%; height: 200px; filter: saturate(2)"
                        :center="gmaps.center"
                        :controlSize="24"
                        :fullscreen-control="false"
                        :clickableIcons="false"
                        :map-type-control="false"
                        :street-view-control="false"
                        :zoom="gmaps.zoom">
                        <Marker v-if="this.gmaps.marker.lat != null" :options="{ position: gmaps.marker, draggable: true, icon: '/icons/location.svg' }" @dragend="markerCallback($event.latLng)" />
                    </GoogleMap>
                </div>
            </div>
            <div v-if="gmaps.selected.area != null" id="selectedLocation" class="row p-1 m-0 bg-white" style="width: 100%; position: relative; background: #ffffff; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15); border-radius: 6px">
                <div class="col">
                    <div class="row py-1 px-0 mx-0 selected">
                        <div class="col">
                            <div class="row my-2" style="font-weight: 600">{{ gmaps.selected.area }}</div>
                            <div class="row" style="font-size: 12px">{{ gmaps.selected.formatted_address }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="navigation" class="row my-2 p-0" style="right: 10px">
                <div class="col">
                    <span @click="save()" style="float: right" class="mx-2 btn btn-usfc-primary">Save</span>
                    <span @click="selector = false" style="float: right" class="mx-2 btn btn-cancel"> Cancel</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { GoogleMap, Marker } from "vue3-google-map";
    import _debounce from "lodash.debounce";
    import axios from "axios";
    import "jquery/dist/jquery.js";
    import _ from "lodash";

    import "bootstrap/dist/css/bootstrap.min.css";
    import "bootstrap/dist/js/bootstrap.bundle.min.js";
    import "bootstrap-icons/font/bootstrap-icons.css";

    export default {
        name: "adminCreate",
        components: { GoogleMap, Marker },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            locations: {
                type: Array,
                default: null,
            },
        },

        computed: {
            getCurrentLocationData() {
                return this.currentLocationData;
            },
            getBodyForm() {
                return this.$store.state.app.currentBodyForm;
            },
            getApproverData() {
                return this.getBodyForm.approver;
            },
            filteredTransporter() {
                if (this.$store.state.app.managerForm.formSearch == "") {
                    this.ascSort();
                    return this.$store.state.app.managerForm.filteredTransporter;
                }

                return this.$store.state.app.managerForm.allTransporter.filter((client) => {
                    return client.full_name.toLowerCase().includes(this.$store.state.app.managerForm.formSearch.toLowerCase());
                });
            },
            currentRouteName() {
                return this.$route.name;
            },
            userFullName() {
                if (this.$store.state.userData.full_name.length > 30) {
                    return this.$store.state.userData.full_name.substring(0, 28) + "...";
                } else {
                    return this.$store.state.app.userData.full_name;
                }
            },
            role() {
                if (this.$store.state.userData.access_level == 5) {
                    return "Manager";
                } else if (this.$store.state.userData.access_level == 4) {
                    return "Admin";
                } else if (this.$store.state.userData.access_level == 3) {
                    return "Sales";
                } else if (this.$store.state.userData.access_level == 2) {
                    return "Client";
                } else {
                    return "Transporter";
                }
            },
        },
        watch: {
            locations: {
                handler: function (newVal) {
                    // Handle prop changes here

                    this.tempLocations = _.cloneDeep(newVal);
                },
                deep: true,
            },
        },
        data() {
            return {
                showPage: false,
                selector: false,
                bodyForm: {
                    full_name: "",
                    email: "",
                    access_level: 2,
                    username: "",
                    phone: "",
                    password: "",
                    birth_date: "",
                    nationality: "",
                    gender: "",
                    photo: "",
                    company: "",
                    street: "",
                    district: "",
                    province: "",
                    city: "",
                    postal_code: "",
                    userId: null,
                },
                gmaps: {
                    zoom: 4,
                    searchQuery: "",
                    center: { lat: 0.4484759, lng: 113.944888 },
                    options: {
                        panControl: false,
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: true,
                        streetViewControl: false,
                        overviewMapControl: false,
                        rotateControl: false,
                    },
                    markerOptions: {
                        icon: "/icons/location.svg",
                    },
                    suggestions: [],
                    marker: {
                        lat: null,
                        lng: null,
                    },
                    selected: {
                        area: null,
                        formatted_address: "",
                        coords: {
                            lat: null,
                            lng: null,
                        },
                    },
                },
                tempLocations: [],
                currentLocationData: {},
                loadForm: "signin",
                menu: "Manage",
                submenu: "Users",
                userAction: false,
                publicRouteNames: ["Signin", "ResetPass", "PassChanged"],
            };
        },
        methods: {
            deleteItem(locationGeometry) {
                console.log(this.tempLocations);
                // Find the index of the object with the matching id
                const index = this.tempLocations.findIndex((item) => {
                    const itemLocation = { lat: item.lat, lng: item.lng };
                    console.log(itemLocation == locationGeometry, itemLocation, "ITEM", locationGeometry, "gemote");
                    return itemLocation.lat === locationGeometry.lat && itemLocation.lng === locationGeometry.lng;
                });

                console.log(index);
                // If index is found (-1 means not found), remove the object at that index
                if (index !== -1) {
                    this.tempLocations.splice(index, 1);
                    setTimeout(() => {
                        this.$emit("onUpdate", this.tempLocations);
                    }, 250);
                }
            },
            save() {
                if (this.currentLocationData.id)
                    this.tempLocations.map((item) => {
                        if (item.id === this.currentLocationData.id) return (item = this.currentLocationData);
                    });
                else this.tempLocations.push(this.currentLocationData);
                console.log(this, this.currentLocationData, "currentloc mau save");
                this.$emit("onUpdate", this.tempLocations);
                this.currentLocationData = {};
                this.selector = false;
            },
            debouncedOnChange() {
                this.clearSuggestion;
                return _debounce(this.suggestionResult, 700).call(this);
            },
            openSelector(item) {
                if (typeof item === "object") {
                    this.currentLocationData = item;
                    this.gmaps.selected.area = item.title;
                    this.gmaps.selected.formatted_address = item.formatted_address;
                    this.gmaps.selected.coords = {
                        lat: item.lat,
                        lng: item.lng,
                    };

                    const coords = { location: { lat: Number(item.lat), lng: Number(item.lng) } };
                    this.selectLocation(coords);
                    this.gmaps.zoom = 14;
                }
                this.selector = true;
                this.$emit("openSelector", true);
            },
            requestGeo() {
                var options = {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                };
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoFailure, options);
                } else {
                    console.log("No support");
                }
            },

            geoSuccess(position) {
                console.log("Success");

                console.log(position.coords);
                let coords = {
                    location: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    },
                };

                this.selectLocation(coords);
            },

            geoFailure(error) {
                console.log("Failure");
                console.log(error);
            },

            getLocDetails(coords) {
                // const PROXY_URL = "https://api.macra.co.id/";
                axios
                    .get("https://api.macra.co.id/maps/place?searchQuery=" + `${coords.lat},${coords.lng}` + "&lat=" + this.gmaps.center.lat + "&lng=" + this.gmaps.center.lng)
                    .then((res) => {
                        console.log(res, "555");
                        let details = res.data.results[0];
                        this.currentLocationData.title = details.name;
                        this.currentLocationData.formatted_address = details.formatted_address;
                        this.currentLocationData.lat = details.geometry.location.lat;
                        this.currentLocationData.lng = details.geometry.location.lng;
                        this.currentLocationData.latitude = details.geometry.location.latitude;
                        this.currentLocationData.longitude = details.geometry.location.longitude;
                        console.log(this.currentLocationData, "current");
                        this.gmaps.selected.area = details.name;
                        this.gmaps.selected.formatted_address = details.formatted_address;
                        // this.pickup_info.address_details = this.gmaps.selected.formatted_address;
                        this.gmaps.selected.coords = {
                            lat: details.geometry.location.lat,
                            lng: details.geometry.location.lng,
                        };
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            clearSuggestion() {
                setTimeout(() => {
                    this.gmaps.suggestions = [];
                }, 150);
            },
            selectLocation(itemIndex) {
                console.log(itemIndex, "LOCAS");
                let loc = itemIndex.location;
                this.gmaps.marker = { lat: loc.lat, lng: loc.lng };
                this.gmaps.center = { lat: loc.lat, lng: loc.lng };
                setTimeout(() => {
                    this.gmaps.suggestions = [];
                    this.gmaps.zoom = 15;
                }, 250);
                this.getLocDetails(loc);
            },
            suggestionResult() {
                this.gmaps.suggestions = [];
                // const PROXY_URL = "https://api.macra.co.id/";
                axios
                    .get("https://api.macra.co.id/maps/place?searchQuery=" + this.gmaps.searchQuery + "&lat=" + this.gmaps.center.lat + "&lng=" + this.gmaps.center.lng)
                    .then((res) => {
                        let results = res.data.results;
                        for (var i = 0; i < res.data.results.length && i < 3; i++) {
                            this.gmaps.suggestions[i] = results[i];
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            markerCallback(e) {
                let coords = {
                    location: {
                        lat: e.lat(),
                        lng: e.lng(),
                    },
                };
                this.selectLocation(coords);
            },
        },

        mounted() {
            // this.getallTransporter();
        },
    };
</script>

<style lang="scss" scoped>
    .locations {
        &-container {
            max-height: 65vh;
            overflow-y: auto;
            overflow-x: hidden;
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                background-color: #f5f5f5;
            }

            &::-webkit-scrollbar {
                width: 6px;
                background-color: #f5f5f5;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #3699ff;
                border-radius: 6px;
            }

            .trash {
                transition: all 0.2s ease;
                &:hover {
                    filter: invert(51%) sepia(27%) saturate(6806%) hue-rotate(329deg) brightness(111%) contrast(104%);
                }
            }
        }
    }
    #suggestions {
        position: absolute;
        z-index: 9999;
        // margin: 0 10px;
        border-radius: 6px;
        width: 95%;
        width: 100%;
        background-color: white;
        cursor: pointer;
        transition: all 0.25s ease;
    }

    #selectedLocation {
        position: absolute;
        z-index: 9999;
        margin: 0 10px;
        border-radius: 6px;
        width: 560px;
    }

    #selectedLocation > .selected {
        width: 100%;
        background-color: white;
        cursor: pointer;
        transition: all 0.25s ease;
    }

    .suggestion:hover {
        color: #3699ff;
    }
    .location-picker {
        padding: 12px;
        text-align: left;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.2);
        transition: all 0.3s ease;
        border-radius: 6px;
    }
    tbody {
        display: block;
        min-height: 55vh;
        width: 100%;
        overflow: auto;

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #f5f5f5;
        }

        &::-webkit-scrollbar {
            width: 6px;
            background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #3699ff;
            border-radius: 6px;
        }

        tr {
            display: table;
            width: 100%;
        }
    }
    #forms::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
    }

    #forms.profile {
        max-height: 45vh;
    }
    #forms.company {
        height: auto;
    }

    #closeModal {
        float: right;
        transform: rotate(45deg);
        border-radius: 50%;
        cursor: pointer;
        transition: 0.3s;
        border: 1px solid transparent;
    }

    #closeModal:hover {
        border: 1px solid black;
    }

    #navigation {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    #stages {
        margin: 0;
        display: flex;
        cursor: default;
        width: 100%;
        .tab {
            flex-grow: 1;
            padding: 12px 22px;
            color: rgba(0, 0, 0, 0.5);
            background-color: #f7f7f7;
            border-bottom: 3px solid rgb(202, 202, 202);

            &:hover {
                border-bottom: 3px solid #3699ff;
                color: rgba(0, 0, 0, 1);
            }
            &.active {
                border-bottom: 3px solid #3699ff;
                color: rgba(0, 0, 0, 1);
            }
        }
    }

    // #stages > .col-auto {
    //     opacity: 0.5;
    // }

    #stages > .col-auto.active {
        opacity: 1;
    }

    #pictureImg {
        cursor: pointer;
        width: 110px;
        height: 110px;
        object-fit: cover;
        object-position: center;
        border-radius: 50%;
    }

    #pictureImgBtn {
        cursor: pointer;
        border-radius: 50%;
        height: 32px;
        width: 32px;
        display: inline-block;
        background-color: #3699ff;

        position: absolute;
        top: 180px;
        left: 53%;
    }

    #pictureImgBtn > #pictureBtn {
        transform: scale(1.2);
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(73deg) brightness(103%) contrast(103%);
    }

    #profilePicture {
        height: 20%;
    }

    #stages {
        overflow-x: scroll;
    }
    #stages::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
    }

    .blur-overlay {
        display: block;
        filter: blur(3px) brightness(90%);
        -webkit-filter: blur(3px) brightness(90%);
        -moz-filter: blur(3px) brightness(90%);
        -o-filter: blur(3px) brightness(90%);
        -ms-filter: blur(3px) brightness(90%);
        pointer-events: none;
    }

    .spacer {
        min-width: 250px;
        width: 20vw;
    }

    /* VUE TRANSITION */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s ease;
    }
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    /* css  */
    myroute {
        cursor: pointer;
    }

    .sales {
        cursor: pointer;
    }

    .sales:hover {
        outline: 1px solid #3699ff;
    }

    .btn-back {
        color: #3699ff;
        outline: 1px solid #3699ff;
    }

    .btn-back:hover {
        color: #3699ff;
        outline: 1px solid #3699ff;
        box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
    }

    .usfc-bg {
        background-color: #fbfbfb;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    input[type="password"] {
        font-family: Verdana;
        letter-spacing: 0.25em;
        font-weight: 900;
    }

    .toggle-password,
    .toggle-password-confirm {
        cursor: pointer;
    }

    .blue-filter {
        filter: invert(45%) sepia(69%) saturate(2325%) hue-rotate(196deg) brightness(108%) contrast(101%);
    }
    .profile-card {
        background-color: white;
        width: 75px;
        height: 100%;
        border-radius: 20px;
        cursor: pointer;
    }

    /* .profile-card:hover {
        border: solid 1px rgba(54, 153, 255, 0.25);
      } */

    .prevent-select {
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
    }

    .parent_arrow {
        transform: rotate(180deg);
    }

    .user-button {
        z-index: 999;
        position: absolute;
        width: auto;
        right: 20px;
        top: 15vh;
        background-color: white;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
        text-align: center;
        border-radius: 6px;
    }

    ul.user-button li {
        position: relative;
        padding: 10px 0;
        width: 200px;
        display: block;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;
        vertical-align: middle;
        line-height: 2em;
    }

    ul.user-button {
        position: absolute;
        top: 75px;
        right: 0;
        padding-left: 0;
    }

    li:hover {
        opacity: 1;
        background: rgba(54, 153, 255, 0.1);
        border-radius: 6px;
        filter: invert(42%) sepia(100%) saturate(546%) hue-rotate(178deg) brightness(107%) contrast(101%);
    }

    .sign-out-button {
        filter: invert(51%) sepia(27%) saturate(6806%) hue-rotate(329deg) brightness(111%) contrast(104%);
    }

    .sign-out-button:hover {
        filter: invert(51%) sepia(27%) saturate(6806%) hue-rotate(329deg) brightness(111%) contrast(104%);
    }

    .top-panel {
        height: 10vh;
    }

    a {
        color: inherit;
        text-decoration: none;
    }

    /* INPUT FORM LABEL STYLE */
    .label-float {
        position: relative;
        padding-top: 13px;
    }

    input {
        width: 100%;
        padding: 2px 0;
        border: 1px solid transparent;
    }

    select {
        width: 100%;
        border: 1px solid transparent;
    }

    .btn {
        font-size: small;
        min-width: 90px;

        border-radius: 6px;
        padding: 10px 25px;
    }

    .btn.btn-cancel {
        border-radius: 6px;
        padding: 10px 25px;
    }

    .btn.btn-cancel:hover {
        border: 1px solid rgba(0, 0, 0, 0.2);
    }

    .btn.btn-cancel:active {
        border: 1px solid rgba(0, 0, 0, 1);
    }

    .btn.btn-usfc-primary {
        background-color: #3699ff;
        color: white;
        border-radius: 6px;
        padding: 10px 25px;
    }

    .btn-usfc-primary:hover {
        background-color: #3699ff;
        color: white;
        box-shadow: 5px 5px 15px 10px rgba(0, 0, 0, 0.05);
    }

    .label-float input {
        border: none;
        background-color: whitesmoke;
        border-radius: 5px;
        outline: none;
        min-width: 250px;
        padding: 15px 20px;
        font-size: 16px;
        transition: all 0.1s linear;
        -webkit-transition: all 0.1s linear;
        -moz-transition: all 0.1s linear;
        -webkit-appearance: none;
        top: 10px;
    }

    .label-float select {
        border: none;
        background-color: whitesmoke;
        border-radius: 5px;
        outline: none;
        min-width: 250px;
        padding: 15px 20px;
        font-size: 16px;
        transition: all 0.1s linear;
        -webkit-transition: all 0.1s linear;
        -moz-transition: all 0.1s linear;
        -webkit-appearance: none;
        top: 10px;
    }

    .label-float input:focus {
        border: 2px solid #3699ff;
        background-color: transparent;
    }

    .label-float select:focus {
        border: 2px solid #3699ff;
        background-color: transparent;
    }

    .label-float input::placeholder {
        color: black;
    }

    .label-float select::placeholder {
        color: black;
    }

    .label-float label {
        pointer-events: none;
        position: absolute;
        top: calc(50% - 8px);
        left: 15px;
        transition: all 0.1s linear;
        -webkit-transition: all 0.1s linear;
        -moz-transition: all 0.1s linear;
        background-color: transparent;
        padding: 5px;
        box-sizing: border-box;
        color: rgba(0, 0, 0, 0.5);
    }

    .label-float input:required:invalid + label {
        color: red;
    }
    .label-float input:focus:required:invalid {
        border: 2px solid red;
    }
    .label-float input:required:invalid + label:before {
        content: "*";
    }
    .label-float input:focus + label,
    .label-float input:not(:placeholder-shown) + label {
        font-size: 13px;
        top: 10px;
        color: #3951b2;
        opacity: 1;
        background-color: transparent;
    }

    .label-float select:required:invalid + label {
        color: red;
    }
    .label-float select:focus:required:invalid {
        border: 2px solid red;
    }
    .label-float select:required:invalid + label:before {
        content: "*";
    }

    label.option-selected {
        font-size: 13px;
        transform: translateY(calc(-55%));
        color: #3951b2;
        background-color: transparent;
    }

    /* FA ICONS CUSTOM */
    .fa-check {
        margin: 0 5px;
        position: relative;
        top: -2px;
        font-size: 12px;
        color: white;
        border-radius: 50%;
        padding: 3px;
        background-color: #3699ff;
    }

    /* * {
    border: 1px solid red;
  } */
</style>
